let signOutFn: null | (() => void) = null;

export function registerSignOut(fn: () => void) {
  signOutFn = fn;
}

export function triggerSignOut() {
  if (signOutFn) {
    signOutFn();
  } else {
    console.warn("triggerSignOut() called before registerSignOut()");
  }
}
